import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { CheckCircle2Icon } from 'lucide-react';
const buyers = [{
  name: 'M.V.',
  location: 'United States'
}, {
  name: 'D.L.',
  location: 'United Kingdom'
}, {
  name: 'C.L.',
  location: 'Canada'
}, {
  name: 'S.M.',
  location: 'Australia'
}, {
  name: 'F.B.',
  location: 'Ireland'
}];
export function FloatingNotification() {
  const [visible, setVisible] = useState(false);
  const [buyer, setBuyer] = useState(buyers[0]);
  useEffect(() => {
    const initial = window.setTimeout(() => setVisible(true), 5000);
    const cycle = window.setInterval(() => {
      setVisible(false);
      window.setTimeout(() => {
        setBuyer(buyers[Math.floor(Math.random() * buyers.length)]);
        setVisible(true);
      }, 850);
    }, 30000);
    return () => {
      window.clearTimeout(initial);
      window.clearInterval(cycle);
    };
  }, []);
  return <AnimatePresence data-id="element-102" data-mp="2fvmyu7hy0txr">
      {visible && <motion.div initial={{
      opacity: 0,
      y: 24
    }} animate={{
      opacity: 1,
      y: 0
    }} exit={{
      opacity: 0,
      y: 12,
      scale: 0.97
    }} transition={{
      duration: 0.25,
      ease: [0.23, 1, 0.32, 1]
    }} className="fixed bottom-4 left-4 z-50 max-w-sm md:bottom-8 md:left-8" data-id="element-103" data-mp="20vv8upfvbw27">
          <div className="flex items-start gap-3 rounded-2xl border border-slate-200 bg-white p-4 shadow-xl" data-id="element-104" data-mp="1mx3wb7gnmig6">
            <div className="mt-0.5 rounded-full bg-emerald-50 p-2" data-id="element-105" data-mp="1hyare3ffnzrm">
              <CheckCircle2Icon className="h-5 w-5 text-emerald-700" data-id="element-106" data-mp="1d6sq1e9hzx64" />
            </div>
            <div data-id="element-107" data-mp="187fyig7om1x7">
              <p className="mb-1 text-xs text-slate-500" data-id="element-108" data-mp="186wlndww23q1">🔔 Verified purchase • a few minutes ago</p>
              <p className="text-sm font-medium text-slate-900" data-id="element-109" data-mp="1394ljwm3bbar">
                <strong data-id="element-110" data-mp="136if60axr1u4">{buyer.name}</strong> from {buyer.location} purchased
              </p>
              <p className="text-sm font-bold text-emerald-700" data-id="element-111" data-mp="z8kpyxh60fqq">Biodecoding Practitioner Kit™</p>
            </div>
          </div>
        </motion.div>}
    </AnimatePresence>;
}